import { apiList } from "../api/apiList";
import axiosInstance from "../api/axiosInstance";

const eventMatchService = {
  saveEventMatch: (payload) => axiosInstance.post(apiList.eventMatchApi,payload),
  saveEventMatchArray: (payload) => axiosInstance.post(apiList.eventMatchArrayApi,payload),
  getEventMatch: () => axiosInstance.get(apiList.eventMatchApi),
  editEventMatch: (id,payload) => axiosInstance.put(`${apiList.eventMatchApi}/${id}`, payload),
}

export default eventMatchService;
